(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  $('.collapsable-content-section').click(function () {
    if ($(this).find('.faq-icon').text() == '+') {
      $(this).find('.faq-icon').text('-');
    } else {
      $(this).find('.faq-icon').text('+');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.klaviyo-form-trigger');
    if (!trigger) return;

    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'T7jCsB']);
  });

  } catch(e) { console.error(e); }
})();
})();
